import _ from 'lodash';
import { i18n } from '@/i18n';

const columns = [
  {
    prop: 'product_type_eq_in_sales_orders',
    label: '销售订单产品类型',
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(i18n.t('salesOrder.productTypes'), (value, key) => ({ value: key, label: value }))
      }
    }
  },
  {
    prop: 'kind_eq_in_sales_orders',
    label: '类型',
    renderCell: {
      component: 'select',
      props: {
        clearable: true,
        options: _.map(i18n.t('salesOrder.kinds'), (value, key) => ({ label: value, value: key }))
      }
    }
  },
  {
    prop: 'ordered_on_gteq_in_sales_orders',
    label: '销售订单下单开始日期',
    renderCell: {
      component: 'datePicker',
      props: {
        valueFormat: 'yyyy-MM-dd'
      }
    }
  },
  {
    prop: 'ordered_on_lteq_in_sales_orders',
    label: '销售订单下单结束日期',
    renderCell: {
      component: 'datePicker',
      props: {
        valueFormat: 'yyyy-MM-dd',
      }
    }
  },
  {
    prop: 'finished_on_month_eq_in_sales_orders',
    label: '完结月份',
    renderCell: {
    component: 'datePicker',
    props: {
        valueFormat: 'yyyy-MM',
        type: 'month'
      }
    }
  },
];

export default columns;

export const columnKeyByProp = _.keyBy(columns, 'prop');
